module.exports = __webpack_public_path__ + "static/media/GT.d291c7ea.png";